import {DateTime} from "luxon";
import {capitalize} from "../../../../lib/TFICLib.ts";
import type {DrillDownLine} from "../../DrillDown/types/types.ts";
import type {PeriodicLine} from "../types/periodicTypes.ts";

export interface MonthColumn {
    label: string;
    shortLabel: string;
}

export function monthColumnsForBuckets(
    buckets: {start_date: string; end_date: string}[],
): MonthColumn[] {
    return buckets.map((bucket) => {
        const start = DateTime.fromISO(bucket.start_date).setLocale("nl");
        const end = DateTime.fromISO(bucket.end_date).setLocale("nl");
        const coversFullMonth =
            start.day === 1 && end.day === end.endOf("month").day;
        return {
            label: coversFullMonth
                ? capitalize(start.toFormat("MMMM yyyy"))
                : `${start.toFormat("d")}–${end.toFormat("d")} ${capitalize(end.toFormat("MMMM yyyy"))}`,
            shortLabel: capitalize(start.toFormat("MMM yy")),
        };
    });
}

export function linesForPeriod(
    lines: PeriodicLine[],
    periodIndex: number | null,
): DrillDownLine[] {
    return lines
        .filter((entry) => periodIndex === null || entry.period_index === periodIndex)
        .map((entry) => entry.line);
}

export function displayColumnsForTable(
    monthColumns: MonthColumn[],
    loading: boolean,
    skeletonMonthCount: number,
): MonthColumn[] {
    if (monthColumns.length > 0) return monthColumns;
    if (!loading) return [];
    const count = Math.max(1, skeletonMonthCount);
    return Array.from({length: count}, (_, index) => ({
        label: `month-${index}`,
        shortLabel: "—",
    }));
}

export function clampYtdMonthIndex(index: number, monthCount: number): number {
    if (monthCount <= 0) return 0;
    return Math.min(Math.max(index, 0), monthCount - 1);
}
